import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux";
import { getUsersAsync } from "../adminSlice";
import MaterialTable from "material-table";
import { RootState } from "typesafe-actions";

export default function UsersTable(){
    const dispatch = useDispatch()
    const _admin = useSelector((state: RootState) => state.adminRdc)

    useEffect(() => {
        dispatch(getUsersAsync())
    }, [])

    return (
        <MaterialTable
        // components={{
        //     Container: Box,
        // }}
        isLoading={_admin.getUsersBusy}
        columns={
            [
                {
                    title: 'Display Name',
                    field: 'displayName',
                },
                {
                    title: 'Email',
                    field: 'email',
                },
                {
                    title: 'Email verified',
                    field: 'emailVerified',
                },
                {
                    title: 'Payment configured',
                    field: 'paymentConnected',
                },                // {
                //     title: 'Phone',
                //     field: 'phoneNumber',
                // },
                {
                    title: 'Disabled',
                    field: 'disabled',
                },
                {
                    title: 'Role',
                    field: 'role',
                },

            ]
        }

        options={{
            paging: false,
            search: true,
            toolbar: true,
        }}

        data={_admin.usersList ? _admin.usersList.map((u) => Object.assign({}, u)) : []}

        title={"Users"}
        />
    )
}